import { Component } from '@angular/core';

@Component({
  selector: 'app-cards2-examples-14',
  templateUrl: './cards2-examples-14.component.html'
})
export class Cards2Examples14Component {}
